import React from 'react';

export default function BurgerIcon({
  className,
  onClick,
  fill,
}: {
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
  fill?: string;
}) {
  return (
    <svg
      className={className}
      onClick={onClick}
      width="30"
      height="17"
      viewBox="0 0 30 17"
      fill={fill || '#6A4192'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="30" height="3" rx="1.5" fill="#6A4192" />
      <rect y="7" width="30" height="3" rx="1.5" fill="#6A4192" />
      <rect y="14" width="30" height="3" rx="1.5" fill="#6A4192" />
    </svg>
  );
}
